<template>
  <BFormGroup
    :label="translatedText(data.name) + (data.mandatory ? ' *' : '')"
    :label-for="`select-input-${data.key}`"
    :state="validation"
  >
    <BFormSelect
        :id="`select-input-${data.key}`"
        :required="data.mandatory"
        :model-value="modelValue"
        :options="options"
        :state="validation"
        @update:model-value="$emit('update:modelValue', $event)"
    >
      <template #first>
        <BFormSelectOption value="" disabled>{{ translatedText({ it: 'Seleziona un\'opzione', en: 'Please select an option', es: 'Por favor seleccione una opción', pt: 'Por favor selecione uma opção', de: 'Bitte wählen Sie eine Option', fr: 'Veuillez sélectionner une option', sl: 'Prosimo, izberite možnost', ru: 'Пожалуйста, выберите вариант', uk: 'Будь ласка, виберіть варіант', pl: 'Proszę wybrać opcję' }) }}</BFormSelectOption>
      </template>
    </BFormSelect>

  </BFormGroup>
</template>

<script setup>
import {computed} from "vue";
import {translate} from "@/domain/utils/translations";
import {inputStatus} from "@/domain/pform/validations";
import {buildOptions} from "@/domain/pform/sortOptions";

defineEmits(['update:modelValue'])
const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  lang: {
    type: String,
    required: true
  },
  modelValue: {
    type: String,
    required: true
  },
  isSubmitted: {
    type: Boolean,
    default: false
  }
})

const options = computed(() => buildOptions(props.data.params, props.lang))

const validation = computed(() => inputStatus(props.data.type, props.data.mandatory, props.modelValue, props.isSubmitted))

const translatedText = (field) => translate(field, props.lang)
</script>
